import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  InstantSerializer_getInstance1n2pd669tdsta as InstantSerializer_getInstance,
  DurationSerializer_getInstance24c8qta2pbnpd as DurationSerializer_getInstance,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance,
  IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import {
  Duration5ynfiptaqcrg as Duration,
  Duration__toString_impl_8d916b1pmuuqkmfodll as Duration__toString_impl_8d916b,
  Duration__hashCode_impl_u4exz62capomnnb6e8m as Duration__hashCode_impl_u4exz6,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.proofs.Proof', this, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('via', false);
        tmp0_serialDesc.addElement_5pzumi_k$('strength', true);
        tmp0_serialDesc.addElement_5pzumi_k$('property', false);
        tmp0_serialDesc.addElement_5pzumi_k$('value', false);
        tmp0_serialDesc.addElement_5pzumi_k$('at', false);
        tmp0_serialDesc.addElement_5pzumi_k$('expiresAt', true);
        tmp0_serialDesc.addElement_5pzumi_k$('signature', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_ywhlqj_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.via_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.strength_1 === 1)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 1, value.strength_1);
        }
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.property_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 3, value.value_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, InstantSerializer_getInstance(), value.at_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.expiresAt_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, InstantSerializer_getInstance(), value.expiresAt_1);
        }
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 6, value.signature_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_ywhlqj_k$(encoder, value instanceof Proof() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = 0;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp11_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.decodeIntElement_941u6a_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, InstantSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, InstantSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.decodeIntElement_941u6a_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, InstantSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, InstantSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp11_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Proof().new_com_lightningkite_lightningserver_sessions_proofs_Proof_dne9rg_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), InstantSerializer_getInstance(), get_nullable(InstantSerializer_getInstance()), StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var ProofClass;
function Proof() {
  if (ProofClass === VOID) {
    class $ {
      constructor(via, strength, property, value, at, expiresAt, signature) {
        strength = strength === VOID ? 1 : strength;
        expiresAt = expiresAt === VOID ? null : expiresAt;
        this.via_1 = via;
        this.strength_1 = strength;
        this.property_1 = property;
        this.value_1 = value;
        this.at_1 = at;
        this.expiresAt_1 = expiresAt;
        this.signature_1 = signature;
      }
      toString() {
        return 'Proof(via=' + this.via_1 + ', strength=' + this.strength_1 + ', property=' + this.property_1 + ', value=' + this.value_1 + ', at=' + this.at_1.toString() + ', expiresAt=' + toString(this.expiresAt_1) + ', signature=' + this.signature_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.via_1);
        result = imul(result, 31) + this.strength_1 | 0;
        result = imul(result, 31) + getStringHashCode(this.property_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.value_1) | 0;
        result = imul(result, 31) + this.at_1.hashCode() | 0;
        result = imul(result, 31) + (this.expiresAt_1 == null ? 0 : this.expiresAt_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.signature_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Proof()))
          return false;
        if (!(this.via_1 === other.via_1))
          return false;
        if (!(this.strength_1 === other.strength_1))
          return false;
        if (!(this.property_1 === other.property_1))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        if (!this.at_1.equals(other.at_1))
          return false;
        if (!equals(this.expiresAt_1, other.expiresAt_1))
          return false;
        if (!(this.signature_1 === other.signature_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_proofs_Proof_dne9rg_k$(seen0, via, strength, property, value, at, expiresAt, signature, serializationConstructorMarker) {
        if (!(93 === (93 & seen0))) {
          throwMissingFieldException(seen0, 93, $serializer_getInstance().descriptor_1);
        }
        var $this = createThis(this);
        $this.via_1 = via;
        if (0 === (seen0 & 2))
          $this.strength_1 = 1;
        else
          $this.strength_1 = strength;
        $this.property_1 = property;
        $this.value_1 = value;
        $this.at_1 = at;
        if (0 === (seen0 & 32))
          $this.expiresAt_1 = null;
        else
          $this.expiresAt_1 = expiresAt;
        $this.signature_1 = signature;
        return $this;
      }
    }
    initMetadataForClass($, 'Proof', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    ProofClass = $;
  }
  return ProofClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.proofs.FinishProof', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('key', false);
        tmp0_serialDesc.addElement_5pzumi_k$('password', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_fsmqjs_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.key_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.password_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_fsmqjs_k$(encoder, value instanceof FinishProof() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return FinishProof().new_com_lightningkite_lightningserver_sessions_proofs_FinishProof_lz2ti9_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var FinishProofClass;
function FinishProof() {
  if (FinishProofClass === VOID) {
    class $ {
      constructor(key, password) {
        this.key_1 = key;
        this.password_1 = password;
      }
      toString() {
        return 'FinishProof(key=' + this.key_1 + ', password=' + this.password_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.key_1);
        result = imul(result, 31) + getStringHashCode(this.password_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FinishProof()))
          return false;
        if (!(this.key_1 === other.key_1))
          return false;
        if (!(this.password_1 === other.password_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_proofs_FinishProof_lz2ti9_k$(seen0, key, password, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_0().descriptor_1);
        }
        var $this = createThis(this);
        $this.key_1 = key;
        $this.password_1 = password;
        return $this;
      }
    }
    initMetadataForClass($, 'FinishProof', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    FinishProofClass = $;
  }
  return FinishProofClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.proofs.IdentificationAndPassword', this, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('type', false);
        tmp0_serialDesc.addElement_5pzumi_k$('property', false);
        tmp0_serialDesc.addElement_5pzumi_k$('value', false);
        tmp0_serialDesc.addElement_5pzumi_k$('password', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_jzyr0r_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.type_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.property_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.value_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 3, value.password_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_jzyr0r_k$(encoder, value instanceof IdentificationAndPassword() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return IdentificationAndPassword().new_com_lightningkite_lightningserver_sessions_proofs_IdentificationAndPassword_qygx5o_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var IdentificationAndPasswordClass;
function IdentificationAndPassword() {
  if (IdentificationAndPasswordClass === VOID) {
    class $ {
      constructor(type, property, value, password) {
        this.type_1 = type;
        this.property_1 = property;
        this.value_1 = value;
        this.password_1 = password;
      }
      toString() {
        return 'IdentificationAndPassword(type=' + this.type_1 + ', property=' + this.property_1 + ', value=' + this.value_1 + ', password=' + this.password_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.type_1);
        result = imul(result, 31) + getStringHashCode(this.property_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.value_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.password_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IdentificationAndPassword()))
          return false;
        if (!(this.type_1 === other.type_1))
          return false;
        if (!(this.property_1 === other.property_1))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        if (!(this.password_1 === other.password_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_proofs_IdentificationAndPassword_qygx5o_k$(seen0, type, property, value, password, serializationConstructorMarker) {
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_1().descriptor_1);
        }
        var $this = createThis(this);
        $this.type_1 = type;
        $this.property_1 = property;
        $this.value_1 = value;
        $this.password_1 = password;
        return $this;
      }
    }
    initMetadataForClass($, 'IdentificationAndPassword', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    IdentificationAndPasswordClass = $;
  }
  return IdentificationAndPasswordClass;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.proofs.ProofOption', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('method', false);
        tmp0_serialDesc.addElement_5pzumi_k$('value', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_8bb0qo_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_3(), value.method_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.value_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, StringSerializer_getInstance(), value.value_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_8bb0qo_k$(encoder, value instanceof ProofOption() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, $serializer_getInstance_3(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, $serializer_getInstance_3(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ProofOption().new_com_lightningkite_lightningserver_sessions_proofs_ProofOption_4olhhq_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_3(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
var ProofOptionClass;
function ProofOption() {
  if (ProofOptionClass === VOID) {
    class $ {
      constructor(method, value) {
        value = value === VOID ? null : value;
        this.method_1 = method;
        this.value_1 = value;
      }
      toString() {
        return 'ProofOption(method=' + this.method_1.toString() + ', value=' + this.value_1 + ')';
      }
      hashCode() {
        var result = this.method_1.hashCode();
        result = imul(result, 31) + (this.value_1 == null ? 0 : getStringHashCode(this.value_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProofOption()))
          return false;
        if (!this.method_1.equals(other.method_1))
          return false;
        if (!(this.value_1 == other.value_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_proofs_ProofOption_4olhhq_k$(seen0, method, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_2().descriptor_1);
        }
        var $this = createThis(this);
        $this.method_1 = method;
        if (0 === (seen0 & 2))
          $this.value_1 = null;
        else
          $this.value_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'ProofOption', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
    ProofOptionClass = $;
  }
  return ProofOptionClass;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.proofs.ProofMethodInfo', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('via', false);
        tmp0_serialDesc.addElement_5pzumi_k$('property', false);
        tmp0_serialDesc.addElement_5pzumi_k$('strength', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_lhotq2_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.via_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, StringSerializer_getInstance(), value.property_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.strength_1 === 1)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 2, value.strength_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_lhotq2_k$(encoder, value instanceof ProofMethodInfo() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = 0;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ProofMethodInfo().new_com_lightningkite_lightningserver_sessions_proofs_ProofMethodInfo_h17m9t_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), IntSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
var ProofMethodInfoClass;
function ProofMethodInfo() {
  if (ProofMethodInfoClass === VOID) {
    class $ {
      constructor(via, property, strength) {
        strength = strength === VOID ? 1 : strength;
        this.via_1 = via;
        this.property_1 = property;
        this.strength_1 = strength;
      }
      toString() {
        return 'ProofMethodInfo(via=' + this.via_1 + ', property=' + this.property_1 + ', strength=' + this.strength_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.via_1);
        result = imul(result, 31) + (this.property_1 == null ? 0 : getStringHashCode(this.property_1)) | 0;
        result = imul(result, 31) + this.strength_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProofMethodInfo()))
          return false;
        if (!(this.via_1 === other.via_1))
          return false;
        if (!(this.property_1 == other.property_1))
          return false;
        if (!(this.strength_1 === other.strength_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_proofs_ProofMethodInfo_h17m9t_k$(seen0, via, property, strength, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_3().descriptor_1);
        }
        var $this = createThis(this);
        $this.via_1 = via;
        $this.property_1 = property;
        if (0 === (seen0 & 4))
          $this.strength_1 = 1;
        else
          $this.strength_1 = strength;
        return $this;
      }
    }
    initMetadataForClass($, 'ProofMethodInfo', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
    ProofMethodInfoClass = $;
  }
  return ProofMethodInfoClass;
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.proofs.KnownDeviceOptions', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('duration', false);
        tmp0_serialDesc.addElement_5pzumi_k$('strength', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_6ufb1k_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, DurationSerializer_getInstance(), new (Duration())(value.duration_1));
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 1, value.strength_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_6ufb1k_k$(encoder, value instanceof KnownDeviceOptions() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = 0;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          var tmp = DurationSerializer_getInstance();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (Duration())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.rawValue_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeIntElement_941u6a_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = DurationSerializer_getInstance();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (Duration())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.rawValue_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeIntElement_941u6a_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return KnownDeviceOptions().new_com_lightningkite_lightningserver_sessions_proofs_KnownDeviceOptions_idlwuj_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DurationSerializer_getInstance(), IntSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_4() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
var KnownDeviceOptionsClass;
function KnownDeviceOptions() {
  if (KnownDeviceOptionsClass === VOID) {
    class $ {
      constructor(duration, strength) {
        this.duration_1 = duration;
        this.strength_1 = strength;
      }
      toString() {
        return 'KnownDeviceOptions(duration=' + Duration__toString_impl_8d916b(this.duration_1) + ', strength=' + this.strength_1 + ')';
      }
      hashCode() {
        var result = Duration__hashCode_impl_u4exz6(this.duration_1);
        result = imul(result, 31) + this.strength_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KnownDeviceOptions()))
          return false;
        if (!equals(new (Duration())(this.duration_1), new (Duration())(other.duration_1)))
          return false;
        if (!(this.strength_1 === other.strength_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_proofs_KnownDeviceOptions_idlwuj_k$(seen0, duration, strength, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_4().descriptor_1);
        }
        var $this = createThis(this);
        $this.duration_1 = duration;
        $this.strength_1 = strength;
        return $this;
      }
    }
    initMetadataForClass($, 'KnownDeviceOptions', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
    KnownDeviceOptionsClass = $;
  }
  return KnownDeviceOptionsClass;
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
var $serializerClass_5;
function $serializer_5() {
  if ($serializerClass_5 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_5 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.proofs.KnownDeviceSecretAndExpiration', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('secret', false);
        tmp0_serialDesc.addElement_5pzumi_k$('expiresAt', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_664omo_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.secret_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, InstantSerializer_getInstance(), value.expiresAt_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_664omo_k$(encoder, value instanceof KnownDeviceSecretAndExpiration() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, InstantSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, InstantSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return KnownDeviceSecretAndExpiration().new_com_lightningkite_lightningserver_sessions_proofs_KnownDeviceSecretAndExpiration_ra57ah_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), InstantSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_5 = $;
  }
  return $serializerClass_5;
}
var $serializer_instance_5;
function $serializer_getInstance_5() {
  if ($serializer_instance_5 === VOID)
    new ($serializer_5())();
  return $serializer_instance_5;
}
var KnownDeviceSecretAndExpirationClass;
function KnownDeviceSecretAndExpiration() {
  if (KnownDeviceSecretAndExpirationClass === VOID) {
    class $ {
      constructor(secret, expiresAt) {
        this.secret_1 = secret;
        this.expiresAt_1 = expiresAt;
      }
      toString() {
        return 'KnownDeviceSecretAndExpiration(secret=' + this.secret_1 + ', expiresAt=' + this.expiresAt_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.secret_1);
        result = imul(result, 31) + this.expiresAt_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KnownDeviceSecretAndExpiration()))
          return false;
        if (!(this.secret_1 === other.secret_1))
          return false;
        if (!this.expiresAt_1.equals(other.expiresAt_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_proofs_KnownDeviceSecretAndExpiration_ra57ah_k$(seen0, secret, expiresAt, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_5().descriptor_1);
        }
        var $this = createThis(this);
        $this.secret_1 = secret;
        $this.expiresAt_1 = expiresAt;
        return $this;
      }
    }
    initMetadataForClass($, 'KnownDeviceSecretAndExpiration', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
    KnownDeviceSecretAndExpirationClass = $;
  }
  return KnownDeviceSecretAndExpirationClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
Companion_instance_2 = new (Companion_2())();
Companion_instance_3 = new (Companion_3())();
Companion_instance_4 = new (Companion_4())();
Companion_instance_5 = new (Companion_5())();
//endregion
//region block: exports
export {
  FinishProof as FinishProof3aqqhk8fegirf,
  IdentificationAndPassword as IdentificationAndPassword3vb92u2w4tqhi,
  KnownDeviceOptions as KnownDeviceOptionsfe8mpyitu56v,
  KnownDeviceSecretAndExpiration as KnownDeviceSecretAndExpirationmwpgc73vjaua,
  ProofMethodInfo as ProofMethodInfo36q47k2opsjdz,
  ProofOption as ProofOption3e15jtcqm4fpv,
  Proof as Proof2281nhajm8urn,
  Companion_instance_0 as Companion_instance346bdrozb6eyq,
  Companion_instance_1 as Companion_instance24h6kgvz9f2xn,
  $serializer_getInstance_5 as $serializer_getInstance145ogcrpmqrjd,
  $serializer_getInstance as $serializer_getInstance1wkzh194ew9wf,
  Companion_instance as Companion_instance1xo6qhmbc85vh,
  $serializer_getInstance_2 as $serializer_getInstanceaabpkscl6h1l,
};
//endregion

//# sourceMappingURL=proofModels.mjs.map
